<sway-cap-generic-baseline [errorsString]="errorsString" *ngIf="baseline && schema$" [readOnly]="readOnly" [tenant_id]="tenant_id" [form]="form"
    [baselineId]="baseline.id" [baselineTemplateItem]="baselineTemplateItem" [readOnly]="readOnly" [schema$]="schema$"
    [schemaFunc]="schemaFunc" [policy$]="policy$" (baselineChange)="onBaselineChange($event)" (baselineErrorChange)="onBaselineErrorChange($event)">

    <ng-container *ngTemplateOutlet="content"></ng-container>
</sway-cap-generic-baseline>

<ng-template #content>
    <ng-container *ngIf="policy$ | async as policy">
        <ng-container *ngIf="authenticationStrengthPolicies$ | async as authenticationStrengthPolicies">
            <sway-baseline-block-item
            [baselineLinkedToPolicy]="!!policy?.id"

            [hasErrors]="
                    errorsString?.includes('grantControls')
                    || errorsString?.includes('authenticationStrength')
                    || errorsString?.includes('operator')
                    " [title]="'Grant Control'">
                <cap-grant-control [authenticationStrengthPolicies]="authenticationStrengthPolicies"
                    [errorsString]="errorsString"  [form]="form" [readOnly]="readOnly"
                    [policy]="policy"></cap-grant-control>
            </sway-baseline-block-item>
        </ng-container>

        <sway-baseline-block-item
                [baselineLinkedToPolicy]="!!policy?.id"
                [hasErrors]="
                errorsString?.includes('userRiskLevels') ||
                errorsString?.includes('signInRiskLevels') ||
                errorsString?.includes('insiderRiskLevels') ||
                errorsString?.includes('platforms') ||
                errorsString?.includes('clientAppTypes') ||
                errorsString?.includes('authenticationFlows')
                " [title]="'Conditions'">
            <sway-cap-conditions [errorsString]="errorsString" [form]="form" [readOnly]="readOnly"
                [policy]="policy"></sway-cap-conditions>
        </sway-baseline-block-item>


        <sway-baseline-block-item
        [baselineLinkedToPolicy]="!!policy?.id"

        [hasErrors]="
                errorsString?.includes('includeApplications')
                " [title]="'Target Resources'">
            <cap-target-resources-control [errorsString]="errorsString" [form]="form" [readOnly]="readOnly"
                [policy]="policy"></cap-target-resources-control>
        </sway-baseline-block-item>


        <sway-baseline-block-item
        [baselineLinkedToPolicy]="!!policy?.id"

            [hasErrors]="
                errorsString?.includes('session')
                " [title]="'Session'">
            <cap-session-control [errorsString]="errorsString" [form]="form" [readOnly]="readOnly"
                [policy]="policy"></cap-session-control>
        </sway-baseline-block-item>


        <sway-baseline-block-item
            [baselineLinkedToPolicy]="!!policy?.id"

            [hasErrors]="
                errorsString?.includes('locations')" [title]="'Network'">
            <ng-container *ngIf="namedLocations$ | async as namedLocations">

                <cap-network-control [namedLocations]="namedLocations" [override]="baselineTemplateItem?.override" [errorsString]="errorsString" [form]="form"
                    [readOnly]="readOnly" [policy]="policy"></cap-network-control>
            </ng-container>
        </sway-baseline-block-item>
    </ng-container>
</ng-template>
